export enum ActivityCategoryTypesEnum {
  IsRepair = 0,
  IsDetection = 1,
}
